/** * @author ❤️❤️❤️ FightFastest 🤎🤎🤎 * @date 🚙 🚒 🛺 24/3/2022 下午 5:18 下午 1:57 🚌🚄🚈🚝 */

<template>
	<vueEcharts :options="option" class="charts"></vueEcharts>
</template>

<script>
import vueEcharts from 'vue-echarts'
require('./index')
export default {
	name: 'bar',
	data() {
		return {
			option: {}
		}
	},
	components: { vueEcharts },
	props: {
		grid: {
			type: Object,
			default: () => ({ left: 30, right: 0, top: 50, bottom: 30 })
		},
		titleStyle: {
			type: Object,
			default: () => {}
		},
		xAxisData: {
			type: Array,
			default: () => []
		},
		lengthData: {
			type: Array,
			default: () => []
		},
		seriesData: {
			type: Array,
			default: () => []
		}
	},
	watch: {
		seriesData: {
			handler() {
				this.$nextTick(function() {
					this.lineOptions()
				})
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		lineOptions() {
			this.$forceUpdate()
			this.option = {
				title: this.titleStyle,
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {
					data: this.lengthData,
					left: '20',
					align: 'left',
					top: '3%',
					itemWidth: 18,
					itemHeight: 10,
					itemGap: 25
				},
				grid: this.grid,
				xAxis: [
					{
						type: 'category',
						data: this.xAxisData,
						axisLine: {
							show: true,
							symbol: ['none', 'arrow'],
							lineStyle: {
								color: '#b0dfd9'
							}
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#014942'
							}
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						axisLabel: {
							textStyle: {
								color: '#009688'
							}
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							symbol: ['none', 'arrow'],
							lineStyle: {
								color: '#b0dfd9'
							}
						},
						splitLine: {
							lineStyle: {
								color: '#dfdfdf',
								type: 'dotter'
							}
						}
					}
				],
				series: this.seriesData
			}
			this.$forceUpdate()
		}
	}
}
</script>

<style scoped lang="less">
.charts {
	width: 100%;
	height: 100%;
}
</style>
